import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { ElTag } from 'element-plus'


export default /*@__PURE__*/_defineComponent({
  __name: 'CandidateTag',
  props: {
    theme: { default: 'default' },
    variant: { default: 'light' },
    size: { default: 'medium' },
    shape: { default: 'square' }
  },
  setup(__props: any) {

const props = __props

const elementType = computed(() => {
  if (props.theme === 'primary' || props.theme === 'default') return 'primary'
  return props.theme
})
const elementEffect = computed(() => {
  if (props.variant === 'dark') return 'dark'
  if (props.variant === 'outline') return 'plain'
  return 'light'
})
const elementSize = computed(() => (props.size === 'medium' ? 'default' : props.size))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElTag), _mergeProps({
    type: elementType.value,
    effect: elementEffect.value,
    size: elementSize.value,
    round: _ctx.shape === 'round'
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["type", "effect", "size", "round"]))
}
}

})